import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import Slider from "../../components/slider";
import EstimateLink from "../../components/estimate-link";
import {IS_MOBILE} from "../../constants/environment";

/**
 *  EcoTax
 */
class EcoTax extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    description: PropTypes.string,
    hideSubsidy: PropTypes.bool,
    hideEstimationButton: PropTypes.bool,
    models: PropTypes.arrayOf(PropTypes.shape({
      vehicleType: PropTypes.string,
      bodyTypes: PropTypes.arrayOf(PropTypes.shape({
        default: PropTypes.bool,
        carId: PropTypes.string,
        bodyTypeTabName: PropTypes.string,
        generations: PropTypes.arrayOf(PropTypes.shape({
          carTypeCode: PropTypes.string,
          grades: PropTypes.arrayOf(PropTypes.shape({
            gradeId: PropTypes.string,
            gradeName: PropTypes.string,
            specialCar: PropTypes.bool,
            variants: PropTypes.arrayOf(PropTypes.shape({
              drive: PropTypes.string,
              engine: PropTypes.string,
              transmission: PropTypes.string,
              gradeCode: PropTypes.string,
              taxInfo: PropTypes.shape({
                //acquisitionTaxPrice: PropTypes.number,
                //acquisitionTaxRate: PropTypes.number,
                //weightTaxPrice: PropTypes.number,
                weightTaxRate: PropTypes.number,
                grTaxRate: PropTypes.bool,
                //taxCut: PropTypes.number,
              }),
              kankyowari: PropTypes.bool,
              subsidy: PropTypes.bool,
            })),
          })),
        })),
      })),
    })),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    description: null,
    hideSubsidy: null,
    hideEstimationButton: null,
    models: null,
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      isOpened: true,
      currentBodyTypeModel: this.getDefaultBodyTypeModel(),
      variantHeight: null,
      isMounted: false,
      currentIndex: 1,
      totalCount: this.getVariantInfoByBodyTypeModel(this.getDefaultBodyTypeModel()).length,
    };
    this.variants = [];
    this.intervalId = null;
  }

  componentDidMount() {
    this.setState({
      isMounted: true,
    });
    if (this.getVariantInfoByBodyTypeModel(this.state.currentBodyTypeModel).length <= ((IS_MOBILE === true) ? 1: 4)) {
    } else {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  render() {

    // ボディタイプ選択
    const renderBodyTypeSelector = () => {
      const bodyTypeInfo = this.getBodyTypeInfo();
      return (
        (bodyTypeInfo && 2 <= bodyTypeInfo.length) ?
          <ul className="EcoTax__body-type-selector">
            {bodyTypeInfo.map((bodyTypeInfo, index) => {
              return (
                <li key={index}>
                  <a
                    className={'EcoTax__body-type-selector__link' + ((bodyTypeInfo.carId === this.state.currentBodyTypeModel) ? ' current': '')}
                    href="javascript:void(0);"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        currentIndex: 1
                      });
                      this.changeBodyType(bodyTypeInfo.carId);
                    }}
                  >
                    {bodyTypeInfo.bodyTypeTabName}
                  </a>
                </li>
              )
            })}
          </ul>
          : null
      )
    };

    // 機種一覧
    const renderVariants = () => {
      if (this.getVariantInfoByBodyTypeModel(this.state.currentBodyTypeModel).length <= ((IS_MOBILE === true) ? 1: 4)) {
        return (
          <div className={'EcoTax__variants fixed' + ((this.state.isOpened === true) ? ' current': '')}>
            {this.getVariantInfoByBodyTypeModel(this.state.currentBodyTypeModel).map((variantInfo, index) => {
              return (
                renderVariant(variantInfo, index)
              )
            })}
          </div>
        )
      } else {
        return (
          <div>
            {this.props.models[0].bodyTypes.map((bodyType, index)=> {
              if (bodyType.carId === this.state.currentBodyTypeModel) {
                return (
                  <div className={'EcoTax__variants' + ((this.state.isOpened === true) ? ' current': '')} key={index}>

                    <div className="EcoTax__variants__pager"><span>{this.state.currentIndex}</span>/<span>{this.getVariantInfoByBodyTypeModel(bodyType.carId).length}</span></div>

                    <Slider
                      ref="slider"
                      settings={{
                        autoplay: false,
                        autoplaySpeed: 3000,
                        speed: 1000,
                        ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                        fade: false,
                        infinite: true,
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        swipe: true,
                        draggable: false,
                        arrows: true,
                        dots: true,
                        adaptiveHeight: false,
                        centerMode: false,
                        centerPadding: 0,
                        waitForAnimate: false,
                        lazyLoad: 'progressive',
                        // appendDots: (dots)=> {
                        //   return (
                        //     <ol>{dots}</ol>
                        //   )
                        // },
                        beforeChange: (oldIndex, newIndex)=> {
                          this.refs.slider.beforeChange(oldIndex, newIndex);
                          this.setState({
                            currentIndex: newIndex + 1
                          })
                        },
                        responsive: [
                          {
                            breakpoint: 767,
                            settings: {
                              speed: 500,
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              centerMode: true,
                              centerPadding: '10%',
                              dots: false,
                            },
                          },
                        ],
                    }}
                    >
                      {this.getVariantInfoByBodyTypeModel(bodyType.carId).map((variantInfo, index) => {
                        return (
                          renderVariant(variantInfo, index)
                        )
                      })}
                    </Slider>
                  </div>
                )
              } else {
                return null;
              }
            })}
          </div>
        )
      }
    };

    // 機種
    const renderVariant = (variantInfo, index) => {
      const ref = 'container' + index;
      this.variants.push(ref);
      //
      const getGradeName = ()=> {
        if (variantInfo.specialCar === true) {
          return variantInfo.gradeId;
        } else {
          if (variantInfo.gradeName && variantInfo.gradeName !== '') {
            return variantInfo.gradeName;
          } else {
            return variantInfo.gradeId;
          }
        }
      };

      // 100th Anniversary Special Edition > 100周年特別記念車
      const convert100th = (text) => {
        if (text && text !== '') {
          text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '2020 WCDOTY受賞記念モデル');
          // text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
          text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
          text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '2020 WCOTY TOP3選出記念モデル');
          text = text.replace('RF 35th SV', '35周年記念車');
          text = text.replace('35th SV', '35周年記念車');
          text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
          text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
          text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
          text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
          text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
          text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
          text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
          text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
          text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
          text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
          text = text.replace('15 SPORT Plus', '15 SPORT＋');
          text = text.replace('XD SPORT Plus', 'XD SPORT＋');
          return text;
        } else {
          return text;
        }
      };

      //
      return (
        <article className="EcoTax__variants__item" key={index}>
          <div className="EcoTax__variants__container" style={(this.state.variantHeight && 0 < this.state.variantHeight) ? {height: this.state.variantHeight} : null}>
            <div ref={ref}>
              <div className="EcoTax__variants__box">
                <div className="EcoTax__variants__box-inner">
                  <h3 className="EcoTax__variants__grade">{convert100th(getGradeName())}</h3>
                  {/*<h3 className="EcoTax__variants__grade">{getGradeName()}</h3>*/}
                  {/*<h3 className="EcoTax__variants__grade">{(variantInfo.gradeName && variantInfo.gradeName !== '') ? variantInfo.gradeName : variantInfo.gradeId}</h3>*/}
                  {(variantInfo.drive && variantInfo.drive !== '' && variantInfo.transmission && variantInfo.transmission !== '') ?
                    <p className="EcoTax__variants__spec">{variantInfo.drive + '/' + variantInfo.transmission}</p>
                    : null}
                </div>
              </div>

              {renderKankyowari(variantInfo)}

              {renderSubsidy(variantInfo)}

              {renderWeightTax(variantInfo)}

              {renderEstimationLink(variantInfo)}

            </div>
          </div>
        </article>
      )
    };

    // 環境性能割
    const renderKankyowari = (variantInfo) => {
        if (variantInfo.kankyowari === true) {
          return (
            <div className="EcoTax__variants__box3">
              <h4 className="EcoTax__variants__heading">自動車税（環境性能割）</h4>
              <p className="EcoTax__variants__subsidy">非課税</p>
            </div>
          )
        } else {
          return (
            <div className="EcoTax__variants__box3">
              <h4 className="EcoTax__variants__heading">自動車税（環境性能割）</h4>
              <p className="EcoTax__variants__subsidy-excluded">課税対象</p>
            </div>
          )
        }
    };

    // クリーンディーゼル補助金
    const renderSubsidy = (variantInfo) => {
      if (!this.props.hideSubsidy) {
        if (variantInfo.subsidy === true) {
          return (
            <div className="EcoTax__variants__box3">
              <h4 className="EcoTax__variants__heading">補助金</h4>
              <p className="EcoTax__variants__subsidy"><span>CEV</span><span>補助金対象</span></p>
              {/*<p className="EcoTax__variants__subsidy"><span>クリーンディーゼル</span><span>補助金対象</span></p>*/}
            </div>
          )
        } else {
          return (
            <div className="EcoTax__variants__box3">
              <h4 className="EcoTax__variants__heading">補助金</h4>
              <p className="EcoTax__variants__subsidy-excluded">対象外</p>
            </div>
          )
        }
      } else {
        return null;
      }
    };

    // エコカー減税
    const renderWeightTax = (variantInfo) => {
      if (variantInfo.taxInfo && 100 <= variantInfo.taxInfo.weightTaxRate) {
        return (
          <div className="EcoTax__variants__box3">
            <h4 className="EcoTax__variants__heading">重量税（エコカー減税）</h4>
            <p className="EcoTax__variants__subsidy">免税</p>
          </div>
        )
      } else if (variantInfo.taxInfo && 0 < variantInfo.taxInfo.weightTaxRate) {
        return (
          <div className="EcoTax__variants__box3">
            <h4 className="EcoTax__variants__heading">重量税（エコカー減税）</h4>
            <p className="EcoTax__variants__subsidy">{variantInfo.taxInfo.weightTaxRate}%減税</p>
          </div>
        )
      } else if (variantInfo.taxInfo && variantInfo.taxInfo.grTaxRate === true) {
        return (
          <div className="EcoTax__variants__box3">
            <h4 className="EcoTax__variants__heading">重量税（エコカー減税）</h4>
            <p className="EcoTax__variants__subsidy-excluded">本則税率</p>
          </div>
        )
      } else {
        return (
          <div className="EcoTax__variants__box3">
            <h4 className="EcoTax__variants__heading">重量税（エコカー減税）</h4>
            <p className="EcoTax__variants__subsidy-excluded">減税対象外</p>
          </div>
        )
      }
    };

    // 見積もりシミュレーションボタン
    const renderEstimationLink = (variantInfo) => {
      if (!this.props.hideEstimationButton && this.props.models[0].vehicleType !== 'Commercial Car') {
        return (
          <div className="EcoTax__variants__box4">
            <EstimateLink {...{
              label: '見積りシミュレーション',
              targetBlank: false,
              color: 'Dark',
              buttonStyle: 'Action',
              linkType: 'Button',
              carId: variantInfo.carId,
              carTypeCode: variantInfo.carTypeCode,
              gradeCode: variantInfo.gradeCode,
              drive: variantInfo.drive,
              mission: variantInfo.transmission,
              engine: variantInfo.engine,
              ecode: null,
              soptions: null,
              direct: 'Result',
            }}/>
          </div>
        )
      } else {
        return null
      }
    };

    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
        anchorPoint={this.props.anchorPoint}
        anchorName={this.props.anchorName}
      >
        <div className="EcoTax">

          {renderBodyTypeSelector()}

          {(this.state.isMounted === true) ? renderVariants(): null}

          {(this.props.description && this.props.description !== '') ?
            <div className="EcoTax__description Wysiwyg">
              <div
                dangerouslySetInnerHTML={{__html: this.props.description}}/>
            </div>
            : null}

        </div>
      </Wrapper>
    )

  }

  // デフォルトCarId取得
  getDefaultBodyTypeModel = () => {
    let bodyTypeModel = null;
    this.props.models[0].bodyTypes.map((bodyType) => {
      if (bodyType.default === true) {
        bodyTypeModel = bodyType.carId;
      }
    });
    return bodyTypeModel;
  };

  // ボディタイプ情報取得
  getBodyTypeInfo = () => {
    let arr = [];
    this.props.models[0].bodyTypes.map((bodyType) => {
      arr.push({
        carId: bodyType.carId,
        bodyTypeTabName: bodyType.bodyTypeTabName,
      });
    });
    return arr;
  };

  // ボディタイプ変更
  changeBodyType = (bodyTypeModel) => {
    this.setState({
      currentBodyTypeModel: bodyTypeModel,
      isOpened: false,
    });
    setTimeout(() => {
      this.setState({
        totalCount: this.getVariantInfoByBodyTypeModel(this.state.currentBodyTypeModel).length,
        currentBodyTypeModel: bodyTypeModel,
        isOpened: true,
      });
    }, 100)
  };

  // 機種情報取得
  getVariantInfoByBodyTypeModel = (bodyTypeModel) => {
    let arr = [];
    this.props.models[0].bodyTypes.map((bodyType) => {
      if (bodyType.carId === bodyTypeModel) {
        const carId = bodyType.carId;
        const carTypeCode = bodyType.generations[0].carTypeCode;
        bodyType.generations[0].grades.map((grade) => {
          //const gradeCode = grade.gradeCode;
          const gradeId = grade.gradeId;
          const gradeName = grade.gradeName;
          const specialCar = grade.specialCar;
          grade.variants.map((variant) => {
            arr.push({
              carId: carId,
              carTypeCode: carTypeCode,
              //gradeCode: gradeCode,
              gradeId: gradeId,
              gradeName: gradeName,
              specialCar: specialCar,
              drive: variant.drive,
              transmission: variant.transmission,
              gradeCode: variant.gradeCode,
              engine: variant.engine,
              kankyowari: variant.kankyowari,
              subsidy: variant.subsidy,
              taxInfo: (variant.taxInfo) ? {
                //acquisitionTaxPrice: variant.taxInfo.acquisitionTaxPrice,
                //acquisitionTaxRate: variant.taxInfo.acquisitionTaxRate,
                //weightTaxPrice: variant.taxInfo.weightTaxPrice,
                weightTaxRate: variant.taxInfo.weightTaxRate,
                grTaxRate: variant.taxInfo.grTaxRate,
                //taxCut: variant.taxInfo.taxCut,
              }: null,
            })
          })
        })
      }
    });
    return arr;
  };

  //
  handleResize = () => {
    if (this.intervalId) clearTimeout(this.intervalId);
    this.intervalId = setTimeout(()=> {
      let maxHeight = 0;
      this.variants.map((ref, index)=> {
        if (this.refs[ref] && this.refs[ref].clientHeight) {
          let height = this.refs[ref].clientHeight;
          if (maxHeight < height) {
            maxHeight = height;
          }
        }
      });
      this.setState({
        variantHeight: maxHeight,
      });
    }, 200);
  };

}

export default EcoTax;



// WEBPACK FOOTER //
// ./src/containers/eco-tax/index.jsx